import type { DealerType } from '@/features/dealers/types/dealers.types';

export type AdjustmentDerivation =
    | { kind: 'hidden' }
    | { kind: 'indeterminate' }
    | { kind: 'resolved'; positive: string; negative: string };

/** Pure lookup over ESW's matrix. No fetching, no store; the OEM branch ignores cthfEnabled. */
export const deriveAdjustmentTypes = (
    noCustomerRefund: boolean,
    dealerType: DealerType | undefined,
    cthfEnabled: boolean,
): AdjustmentDerivation => {
    if (!noCustomerRefund) return { kind: 'hidden' };
    if (dealerType === undefined) return { kind: 'indeterminate' };

    switch (dealerType) {
        case 'oem':
        case 'oem_group':
            return { kind: 'resolved', positive: 'MCB', negative: 'MDC' };
        case 'dealer':
        case 'dealer_group':
        case 'franchise_dealer': {
            const code = cthfEnabled ? 'DCCTHF' : 'DRF';
            return { kind: 'resolved', positive: code, negative: code };
        }
        default: {
            // A new DealerType member must fail compilation here, not fall through to a guess.
            const unhandledDealerType: never = dealerType;
            void unhandledDealerType;
            return { kind: 'indeterminate' };
        }
    }
};
